import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { BurstFeatureCollection, BurstFeature } from './types';
import { sec } from './security';

const { VITE_ARI_SERVICE_HOST } = import.meta.env;

// Define a service using a base URL and expected endpoints
export const ariService = createApi({
  reducerPath: 'ariService',
  baseQuery: fetchBaseQuery({
    baseUrl: VITE_ARI_SERVICE_HOST,
    prepareHeaders: async (headers) => {
      const access_token = await sec.getAccessTokenSilently()();
      if (access_token) headers.set('Authorization', `Bearer ${access_token}`);
      return headers;
    }
  }),
  endpoints: (builder) => ({
    getAriBursts: builder.query<
      BurstFeatureCollection,
      {
        aoi: string;
        orbit_pass?: 'ASCENDING' | 'DESCENDING';
        start_date?: string;
        end_date?: string;
        min_rfi_count?: number;
        sort?: string;
        limit?: number;
        include_histogram?: boolean;
      }
    >({
      query: (params) => ({
        url: '/bursts',
        params
      })
    }),
    getBurst: builder.query<BurstFeature, { burst_id: string }>({
      query: ({ burst_id }) => ({
        url: `/burst/${burst_id}`,
        method: 'GET'
      })
    })
  })
});

export const { useLazyGetAriBurstsQuery, useGetBurstQuery } = ariService;
